import produce from 'immer';
import { GEAR_MINING_LOG_LIST_REQUEST } from '../../constants/log/gearMiningLogConstants';

const initialState = {

};

const gearMiningLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case GEAR_MINING_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default gearMiningLogReducer;
